(() => {
  if (customElements.get('jh-shop-only')) return;

  class JHShopOnly extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.cards = Array.from(this.querySelectorAll('[data-jhsc-card]'));
      this.family = 'all';
      this.querySelector('[data-jhsc-tools]').hidden = false;
      const signal = this.controller.signal;

      this.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        const familyControl = event.target.closest('[data-jhsc-family]');
        const modeControl = event.target.closest('[data-jhsc-mode]');
        const resetControl = event.target.closest('[data-jhsc-reset]');
        if (familyControl && this.contains(familyControl)) {
          this.family = familyControl.dataset.jhscFamily;
          this.updateFilters();
          if (familyControl.tagName === 'A') {
            event.preventDefault();
            this.querySelector('.jhsc-collection').scrollIntoView({
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
              block: 'start',
            });
          }
        } else if (modeControl && this.contains(modeControl)) {
          this.setImageMode(modeControl.dataset.jhscMode);
        } else if (resetControl && this.contains(resetControl)) {
          this.family = 'all';
          this.updateFilters();
        }
        // Do not intercept product links, variant selectors, forms or quick add.
      }, { signal });
      this.querySelector('[data-jhsc-select]').addEventListener('change', (event) => {
        this.family = event.target.value;
        this.updateFilters();
      }, { signal });
      this.setImageMode('roller');
      this.updateFilters();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    setImageMode(mode) {
      this.dataset.imageMode = mode === 'gallon' ? 'gallon' : 'roller';
      this.querySelectorAll('[data-jhsc-mode]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.jhscMode === this.dataset.imageMode));
      });
    }

    updateFilters() {
      let count = 0;
      this.cards.forEach((card) => {
        const families = card.dataset.jhscFamilies.trim().split(/\s+/);
        card.hidden = this.family !== 'all' && !families.includes(this.family);
        if (!card.hidden) count += 1;
      });
      this.querySelectorAll('.jhsc-families [data-jhsc-family]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.jhscFamily === this.family));
      });
      this.querySelector('[data-jhsc-select]').value = this.family;
      this.querySelector('[data-jhsc-count]').textContent = `${count} ${count === 1 ? 'color' : 'colors'}`;
      this.querySelector('[data-jhsc-empty]').hidden = count > 0 || this.cards.length === 0;
      this.querySelector('.jhsc-results [data-jhsc-reset]').hidden = this.family === 'all';
    }
  }

  customElements.define('jh-shop-only', JHShopOnly);
})();
